export const applicationSelector = ({ app }) => ({
	trackingPixelUrl: `${app.trackingUrl}/imageVerifyVisit?a=${app.trackingId}`,
	environment: app.environment,
	statusCode: app.statusCode,
	errorMessage: app.error
});

export default applicationSelector;
